import Vue from 'vue';

const busEvent = new Vue();
export default busEvent;



// WEBPACK FOOTER //
// ./src/utils/busEventUtils.js